import request from "@/utils/request";

export async function all() {
  return await request.get("/friend-lists?loyalty", { data: null });
}

export async function get(id) {
  return await request.get(`/friend-lists/${id}?loyalty`, { data: null });
}

export async function patch(code, data) {
  return await request.put(`/friend-lists/${code}?loyalty`, { ...data });
}

export async function levels() {
  return await request.get("/friend-list-levels?loyalty", { data: null });
}

export const invite = {
  async get(code) {
    return await request.get(`/friend-list-invites/${code}?loyalty`, {
      data: null,
    });
  },
  async validate(code, data = {}) {
    return await request.post(`/friend-list-invites/${code}/validate`, data);
  },
  async accept(code, data = {}) {
    return await request.post(
      `/friend-list-participants/invite/${code}?loyalty`,
      data
    );
  },
};

export const participant = {
  async all(code) {
    return await request.get(`/friend-lists/${code}/participants?loyalty`, {
      data: null,
    });
  },
  async get(friendListId, id) {
    return await request.get(`/friend-list-participants/${id}?loyalty`, {
      data: null,
    });
  },
  async delete(code, id) {
    return await request.delete(
      `/friend-lists/${code}/participants/${id}?loyalty`
    );
  },
};

export const level = {
  async all(code) {
    return await request.get(`/friend-list-levels?loyalty`, {
      data: null,
    });
  },
  async get(friendListId, code) {
    return await request.get(`/friend-lists/${code}/levels?loyalty`, {
      data: null,
    });
  },
};
